/*
  Global constants
*/

const BASKET_TYPES = {
  FULLY_LMN: 'Lmn',
  FULLY_ELIGIBLE: 'Fully Eligible',
  MIXED_BASKET: 'Mixed Basket',
  MIXED_BASKET_WITH_LMN: 'Mixed Basket & Lmn',
  FULLY_INELIGIBLE: 'Fully Ineligible',
}

const CARD_TYPES = {
  HSA: {
    value: 'hsa',
    label: 'HSA',
  },
  FSA: {
    value: 'fsa',
    label: 'FSA',
  },
  VISA: {
    value: 'visa',
    label: 'Visa',
  },
  AMEX: {
    value: 'amex',
    label: 'Amex',
  },
  MASTERCARD: {
    value: 'mastercard',
    label: 'Mastercard',
  },
  DISCOVER: {
    value: 'discover',
    label: 'Discover',
  },
  OTHER: {
    value: 'other',
    label: 'Other',
  },
}

const CARD_CATEGORY = {
  HSA_FSA: 'hsaFsa',
  CREDIT_DEBIT: 'creditDebit',
}

const ALERT_TYPE = {
  FULLY_LMN: 'fullyLmn',
  FULLY_ELIGIBLE: 'fullyEligible',
  FULLY_INELIGIBLE: 'fullyIneligible',
  MIXED_BASKET: 'mixedBasket',
  PARTIAL_AUTH: 'partialAuth',
}

const GENERIC_ERROR_MESSAGE = 'There was an error communicating with Sika. Please try again later.'

const PAYMENT_PROCESSORS = {
  STRIPE: 'stripe',
  RAINFOREST: 'rainforest',
}

const CDN_LOCATION = String(process.env.CDN_LOCATION) === 'latest' ? 'latest' : `v${String(process.env.CDN_LOCATION)}`
const CDN_PATH = `${String(process.env.CDN_HOST)}/${CDN_LOCATION}`

const LMN_PROVIDER = {
  BELUGA: 'Beluga',
  DRB: 'Dr.B',
}

const RAINFOREST_PAYMENT_STATES = {
  ATTEMPTED: 'attempted',
  APPROVED: 'approved',
  DECLINED: 'declined',
  ERROR: 'error',

}

const MERCHANT_PLATFORM = {
  WOOCOMMERCE: 'woocommerce',
  SHOPIFY: 'shopify',
  DIRECT: 'direct',

}

export {
  ALERT_TYPE,
  BASKET_TYPES,
  CARD_CATEGORY,
  CARD_TYPES,
  CDN_PATH,
  GENERIC_ERROR_MESSAGE,
  LMN_PROVIDER,
  PAYMENT_PROCESSORS,
  RAINFOREST_PAYMENT_STATES,
  MERCHANT_PLATFORM,
}
